import mod from "-!./PayDashboard.js?vue&type=script&lang=js&"; export default mod; export * from "-!./PayDashboard.js?vue&type=script&lang=js&"